import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { Message, ChatState } from '@/types';

const initialState: ChatState = {
  session_id: undefined,
  messages: [],
  isLoading: false,
  error: null,
};

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    addMessage: (state, action: PayloadAction<Message>) => {
      state.messages.push(action.payload);
      state.error = null;
    },
    setSessionId: (state, action: PayloadAction<string>) => {
      state.session_id = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    resetChat: (state) => {
      state.session_id = undefined;
      state.messages = [];
      state.isLoading = false;
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  addMessage,
  setSessionId,
  setLoading,
  setError,
  resetChat,
  clearError,
} = chatSlice.actions;

export default chatSlice.reducer;